let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hU82q")).then(() => parcelRequire('kvhCa'));